import { makeMonitorRepository } from "../../../repositories/repositoryBuilders.js";
import Company from "../../../../models/Company.js";
import session from "../../../session.js";
import UploadService from "../../../services/UploadService.js";

/**
 * Service responsible for all data exchange required when importing
 * from a SIE file.
 */
export default class SieImportService {
	constructor() {
		this._uploadService = new UploadService({
			uploadPath: "/Shared/Import/Upload",
		});

		const antiForgeryToken = session.getAntiForgeryToken();

		this._sieRepository = makeMonitorRepository({
			route: "/Shared/Import/Sie",
			antiForgeryToken,
		});

		this._chartOfAccountsRepository = makeMonitorRepository({
			route: "/Shared/Company/#companyId/ChartOfAccounts/",
			responseHandlers: [{ test: 404, handle: () => null }],
			antiForgeryToken,
		});

		this._budgetRepository = makeMonitorRepository({
			route: "/Accounting2/Company/#companyId/Budget/",
			responseHandlers: [{ test: 404, handle: () => null }],
			antiForgeryToken,
		});
	}

	uploadFile(file) {
		return this._uploadService.uploadFile(file);
	}

	async getSieImportedData({ companyId, agencyId }) {
		const data = await this._sieRepository.save({
			model: { companyId, agencyId },
			notify: false,
		});

		const companyData = await this._retrieveCompanyData({
			importCompanyInfo: data.importCompanyInfo,
			companyId,
			agencyId,
		});

		return { ...data, ...companyData };
	}

	async _retrieveCompanyData({ importCompanyInfo, companyId, agencyId }) {
		if (!importCompanyInfo) return {};

		companyId ||= this._makeCompanyId({ importCompanyInfo, agencyId });

		const filters = { filter: { companyId }, notify: false };

		const [chartOfAccounts, budgets] = await Promise.all([
			this._chartOfAccountsRepository.get(filters),
			this._budgetRepository.get(filters),
		]);

		return { chartOfAccounts, budgets };
	}

	_makeCompanyId({ importCompanyInfo: { businessIdentityCode }, agencyId }) {
		return Company.createAgencyAttachedCompanyId(
			agencyId,
			businessIdentityCode,
		);
	}
}
